import { render } from "./IconVimeo.vue?vue&type=template&id=192d9092"
import script from "./IconVimeo.vue?vue&type=script&lang=js"
export * from "./IconVimeo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__